import axios from 'axios';
import {
  JurisprudenciaArquivo,
  JurisprudenciaCreateRequest,
  JurisprudenciaCreateRequestClient,
  JurisprudenciaCreateResponse,
  JurisprudenciaDeleteResponse,
  JurisprudenciaModelResponse,
  TextoJurisprudenciaResponse,
} from '../../types/Jurisprudencia.types';

import {
  PagedJurisprudenciaData,
  PagedJurisprudenciaDataRequest,
  SingleJurisprudenciaData,
  // JurisprudenciaData,
  // JurisprudenciaDeleteResponse,
} from '../../types/Jurisprudencia.types';

import ApiClient, { IApiClient } from '../ApiClient';
import { getToken } from '../utils';

interface IJurisprudenciaApiClient {
  create(data: JurisprudenciaCreateRequest): Promise<JurisprudenciaCreateResponse | undefined>;
  // list(): Promise<JurisprudenciaData[] | undefined>;
  listPaged(data: PagedJurisprudenciaDataRequest): Promise<PagedJurisprudenciaData | undefined>;
  getById(id: string): Promise<SingleJurisprudenciaData | undefined>;
  update(id: string, data: JurisprudenciaCreateRequest): Promise<JurisprudenciaCreateResponse | undefined>;
  delete(id: string): Promise<JurisprudenciaDeleteResponse | undefined>;
  getDocumento(id: string): Promise<JurisprudenciaDeleteResponse[] | undefined>;
  getTexto(id: string): Promise<TextoJurisprudenciaResponse[] | undefined>;
  salvarArquivo(file: File): Promise<JurisprudenciaArquivo | undefined>;
  getJurispridenciaModelos(id: string): Promise<JurisprudenciaModelResponse | undefined>;
}

class JurisprudenciaApiClient implements IJurisprudenciaApiClient {
  apiClient: IApiClient;

  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }

  async create(data: JurisprudenciaCreateRequest): Promise<JurisprudenciaCreateResponse | undefined> {
    return this.apiClient.post<JurisprudenciaCreateRequest, JurisprudenciaCreateResponse>('/jurisprudencia', data);
  }

  // async list(): Promise<JurisprudenciaData[] | undefined> {
  //   return this.apiClient.get<JurisprudenciaData[]>('/jurisprudencias');
  // }

  async listPaged(data: PagedJurisprudenciaDataRequest): Promise<PagedJurisprudenciaData | undefined> {
    return this.apiClient.post<PagedJurisprudenciaDataRequest, PagedJurisprudenciaData>('/jurisprudencia_paged', data);
  }

  async getById(id: string): Promise<SingleJurisprudenciaData | undefined> {
    return this.apiClient.get<SingleJurisprudenciaData>(`/jurisprudencia/${id}`);
  }

  async update(id: string, data: JurisprudenciaCreateRequest): Promise<JurisprudenciaCreateResponse | undefined> {
    return this.apiClient.put<JurisprudenciaCreateRequest, JurisprudenciaCreateResponse>(`/jurisprudencia/${id}`, data);
  }

  async delete(id: string): Promise<JurisprudenciaDeleteResponse | undefined> {
    return this.apiClient.delete<JurisprudenciaDeleteResponse>(`/jurisprudencia/${id}`);
  }

  async getDocumento(id: string): Promise<JurisprudenciaDeleteResponse[] | undefined> {
    return this.apiClient.get<JurisprudenciaDeleteResponse[]>(`/modelos/jurisprudencia/${id}`);
  }

  async getTexto(id: string): Promise<TextoJurisprudenciaResponse[] | undefined> {
    return this.apiClient.get<TextoJurisprudenciaResponse[]>(`/textos/jurisprudencia/${id}`);
  }

  async getJurispridenciaModelos(id: string): Promise<JurisprudenciaModelResponse | undefined> {
    return this.apiClient.get<JurisprudenciaModelResponse>(`/modelos/jurisprudencia/obterPorIdModelo/${id}`);
  }

  async salvarArquivo(file: File): Promise<JurisprudenciaArquivo | undefined> {
    const formData = new FormData();
    formData.append('Arquivo', file);

    const resp = await fetch(`${process.env.REACT_APP_API_BASE_URL}jurisprudencia/documentos`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
      body: formData,
    });

    if (!resp.ok) {
      const text = await resp.text();
      throw new Error(`Upload falhou (${resp.status}): ${text}`);
    }

    return resp.json();
  }
}

export default class JurisprudenciaService {
  jurisprudenciaApiClient: IJurisprudenciaApiClient;

  constructor() {
    this.jurisprudenciaApiClient = new JurisprudenciaApiClient(new ApiClient());
  }

  async create(data: JurisprudenciaCreateRequestClient): Promise<JurisprudenciaCreateResponse | undefined> {
    const request: JurisprudenciaCreateRequest = {
      idJurisprudencia: undefined,
      nome: data.nome,
      tribunal: data.tribunal,
      orgao: data.orgao,
      tipoDecisao: data.tipoDecisao,
      dataPublicacao: `${data.dataPublicacao}-01-01T00:00:00`,
      assunto: data.assunto,
      area: data.area,
      valorTexto: data.valorTexto,
      enderecoArquivo: data.enderecoArquivo,
    };
    return this.jurisprudenciaApiClient.create(request);
  }

  // async list(): Promise<JurisprudenciaData[] | undefined> {
  //   return this.jurisprudenciaApiClient.list();
  // }

  async listPaged(data: PagedJurisprudenciaDataRequest): Promise<PagedJurisprudenciaData | undefined> {
    return this.jurisprudenciaApiClient.listPaged(data);
  }

  async getById(id: string): Promise<SingleJurisprudenciaData | undefined> {
    return this.jurisprudenciaApiClient.getById(id);
  }

  async update(id: string, data: JurisprudenciaCreateRequestClient): Promise<JurisprudenciaCreateResponse | undefined> {
    const request: JurisprudenciaCreateRequest = {
      ...data,
      idJurisprudencia: id,
    };
    return this.jurisprudenciaApiClient.update(id, request);
  }

  async delete(id: string): Promise<JurisprudenciaDeleteResponse | undefined> {
    return this.jurisprudenciaApiClient.delete(id);
  }

  async getDocumento(id: string): Promise<JurisprudenciaDeleteResponse[] | undefined> {
    return this.jurisprudenciaApiClient.getDocumento(id);
  }

  async getTexto(id: string): Promise<TextoJurisprudenciaResponse[] | undefined> {
    return this.jurisprudenciaApiClient.getTexto(id);
  }

  async getJurispridenciaModelos(id: string): Promise<JurisprudenciaModelResponse | undefined> {
    return this.jurisprudenciaApiClient.getJurispridenciaModelos(id);
  }

  async salvarArquivo(arquivo: File): Promise<JurisprudenciaArquivo | undefined> {
    return this.jurisprudenciaApiClient.salvarArquivo(arquivo);
  }
}
